import {languageActionType} from '../../constants';

export default (state = [], action) => {
    switch (action.type) {
        case languageActionType.UPDATE_LANGUAGE:
            return action.payload;
        default:
            return state;
    }
};
